export default __webpack_public_path__ + "static/media/Campfire.38524897.gif";